<template lang="pug">
  .wrap
    page-title Add a new Product Category

    category-form(v-model='category' @save='onSave')
      template(slot='saveOptions')
        el-checkbox(v-model='createAnother') Save and create another

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CrudMixin from "@/shared/mixins/Crud";
import PageTitle from "@/shared/components/layout/PageTitle";
import CategoryForm from "@/brapp/components/shared/categories/CategoryForm";

const getInitialCategoryData = () => {
  return {
    name: ""
  };
};

export default {
  components: { PageTitle, CategoryForm },
  mixins: [CrudMixin],
  data() {
    return {
      createAnother: true,
      category: getInitialCategoryData()
    };
  },
  computed: {
    ...mapGetters({
      activeCompany: "auth/activeCompany"
    })
  },
  methods: {
    ...mapActions({
      createCategory: "products/createCategory"
    }),
    onSave({ valid }) {
      if (!valid) {
        this.$notify({
          title: "Error",
          message: "Please fix the validation errors",
          type: "error"
        });
        return;
      }

      const newData = {
        ...this.category,
        company: this.activeCompany.id
      };

      this.wrapApiAction(this.createCategory)({ data: newData }).then(data => {
        if (this.createAnother) {
          this.category = getInitialCategoryData();
        } else {
          this.$router.push({
            name: "brapp:sales:categoryEdit",
            params: { categoryId: data.id }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
